import {createAction, props} from '@ngrx/store';
import {SidePanelSection, SidePanelState} from './index';

export const changeSidePanelState = createAction('[Layout] - set side-panel state', props<{sidePanel: Partial<SidePanelState>}>());
export const toggleSidePanel = createAction('[Layout] - toggle side panel', props<{section: SidePanelSection}>());
export const closeSidePanel = createAction('[Layout] - close side panel');
